/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EDeviceEventTypeIndicator {
  PingInProgress = 1,
  PingSuccess = 2,
  PingFailed = 3,
  ResetInProgress = 4,
  ResetSuccess = 5,
  ResetFailed = 6
}
